import { ButtonHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
}

const activeStyles = css`
  border-color: ${theme.colors.mainBlue};
  background: ${theme.colors.blue500};
  color: ${theme.colors.mainBlue};
`;

const StyledPill = styled.button<{ $isActive?: boolean }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  max-width: 100%;
  height: 20px;
  padding: 0 4px;
  font: inherit;
  border-radius: 100px;
  border: 1px solid ${theme.colors.secondary300};
  background: ${theme.colors.secondary300};
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  outline: none;
  color: ${theme.colors.secondary600};
  &:not(:disabled):hover {
    cursor: pointer;
    ${activeStyles};
  }
  ${({ $isActive }) => $isActive && activeStyles}}
`;

const Pill = ({ children, isActive, type, ...props }: IProps) => (
  <StyledPill {...props} type={type || 'button'} $isActive={isActive}>
    {children}
  </StyledPill>
);

export default Pill;
